import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('stockItem', 'stockItems');

const customActions = {
  async LOAD_stockItem({ rootGetters, commit }, id) {
    const i = odata.parseId(id);
    const data = await odata.o(rootGetters)
      .get(`stockItems(${i})`)
      .query({
        $expand: 'DeliveryNote($expand=Farm),CanEndInspections,CanningProcesses,ProcessCheckSheets($expand=SaltBins,DrainedWeights),BatchPrintingVerifications',
      });
    commit('SET_stockItem', data);
    return data;
  },
  async LOAD_stockItemChildren({ rootGetters }, id) {
    const i = odata.parseId(id);
    const data = await odata.o(rootGetters)
      .get('stockItems')
      .query({
        $filter: `IsDeleted eq false AND ParentStockItemId eq ${i}`,
        $expand: 'DeliveryNote($expand=Farm),CanEndInspections,CanningProcesses,ProcessCheckSheets,BatchPrintingVerifications',
      });
    return data;
  },
  async LOAD_stockItems({ rootGetters, commit }) {
    const data = await odata.o(rootGetters)
      .get('stockItems')
      .query({
        $filter: 'IsDeleted eq false',
        $orderby: 'created desc',
        $expand: 'DeliveryNote($expand=Farm)',
      });
    commit('SET_stockItems', data);
    return data;
  },
  async LOAD_stockItemsByDeliveryNote({ rootGetters }, deliveryNoteId) {
    const data = await odata.o(rootGetters)
      .get('stockItems')
      .query({
        $filter: `IsDeleted eq false AND deliveryNoteId eq ${deliveryNoteId}`,
        $orderby: 'created desc',
      });
    return data;
  },
  async LOAD_availableStockItems({ rootGetters, commit }) {
    const data = await odata.o(rootGetters)
      .get('stockItems')
      .query({
        $filter: 'IsDeleted eq false AND State eq \'Received\' OR State eq \'Receipted\'',
        $orderby: 'created desc',
        $expand: 'DeliveryNote($expand=Farm)',
      });
    commit('SET_stockItems', data);
    return data;
  },
  async MERGE_stockItems({ rootGetters }, mergeStockItemModel) {
    const data = await odata.o(rootGetters)
      .post('mergeStockItems', mergeStockItemModel)
      .query();
    return data;
  },
  async SPLIT_stockItems({ rootGetters }, splitStockItemModel) {
    console.debug(splitStockItemModel);
    // eslint-disable-next-line no-param-reassign
    splitStockItemModel['@odata.etag'] = undefined;
    const data = await odata.o(rootGetters)
      .post('splitStockItems', splitStockItemModel)
      .query();
    return data;
  },
  async BATCH_stockItems({ rootGetters, dispatch }, batchStockItemsModel) {
    console.debug(batchStockItemsModel);
    const data = await odata.o(rootGetters)
      .post('batchStockItems', batchStockItemsModel)
      .query();
    await dispatch('LOAD_processingStockItems');
    return data;
  },
  async COMPLETE_stockItem({ rootGetters }, stockItem) {
    const data = await odata.o(rootGetters)
      .post('completeStockItem', stockItem)
      .query();
    return data;
  },
  async LOAD_processingStockItems({ rootGetters, commit }) {
    const data = await odata.o(rootGetters)
      .get('stockItems')
      .query({
        $filter: 'IsDeleted eq false AND (State eq \'Processing\' OR State eq \'Split\' OR State eq \'Processing-Split\' OR State eq \'Processing-Batched\' OR State eq \'Batched\')',
        $orderby: 'created desc',
        $expand: 'DeliveryNote($expand=Farm),CanEndInspections,CanningProcesses,ProcessCheckSheets,BatchPrintingVerifications,StockItemLinks($expand=ChildStockItem($expand=DeliveryNote($expand=Farm)))',
      });
    commit('SET_processingStockItems', data);
    return data;
  },
  async UPDATE_stockItem({ rootGetters }, data) {
    const i = odata.parseId(data.id);
    await await odata.o(rootGetters)
      .patch(`stockItems(${i})`, data)
      .query();

    return data;
  },
};

export default { ...actions, ...customActions };
